import React, { useState, useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  PDFViewer,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { Button, Typography, Divider } from "antd";
import { DownloadOutlined, ArrowLeftOutlined } from "@ant-design/icons"; // Iconos de Ant Design
import { useMediaQuery } from "react-responsive"; // Necesitarás instalar: npm install react-responsive
import { use } from "react";

const { Title } = Typography;

const BORDER_COLOR = "#000";
const BORDER_WIDTH = 1;

const styles = StyleSheet.create({
  page: {
    padding: 20,
    paddingBottom: 50, // 🔥 Reservamos espacio para el footer
    fontSize: 10,
    fontFamily: "Helvetica",
  },

  title: {
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10,
  },
  table: {
    display: "flex",
    flexDirection: "column",
    borderWidth: BORDER_WIDTH,
    borderColor: BORDER_COLOR,
    borderStyle: "solid",
    marginTop: 10,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    borderRightWidth: BORDER_WIDTH,
    borderBottomWidth: BORDER_WIDTH,
    borderColor: BORDER_COLOR,
    borderStyle: "solid",
    padding: 4,
  },
  // Para la última celda de la fila quitamos el borde derecho
  lastCell: {
    borderRightWidth: 0,
  },
  // Para la última fila quitamos el borde inferior en celdas
  lastRow: {
    borderBottomWidth: 0,
  },
  signatureLine: {
    borderBottomWidth: BORDER_WIDTH,
    borderColor: BORDER_COLOR,
    height: 40,
    marginTop: 10,
  },
  tableRowColored: {
    backgroundColor: "#bbb",
    borderWidth: 1,
    borderColor: "#999",
    borderStyle: "solid",
  },

  centeredText: {
    textAlign: "center",
  },
  underlined: {
    fontSize: 10,
    textAlign: "justify",
    marginBottom: 5,
    fontWeight: "normal", // Sin negrita
    borderBottomColor: "#000",
    textDecoration: "underline", // Subraya el texto
    fontWeight: "normal !important", // Asegura que no tenga negrita
  },
  boldText: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold", // más negrita real
  },

  content: {
    flexGrow: 1,
  },

  footerCodeContainer: {
    position: "absolute",
    bottom: 30, // Distancia desde el borde inferior
    left: 30,
    right: 30,
    textAlign: "left",
  },

  footerCode: {
    fontSize: 10,
    fontFamily: "Helvetica",
    color: "black",
    letterSpacing: 1.5,
  },

  paragraph: {
    fontSize: 10,
    lineHeight: 1.5, // Aumenta para más espacio entre líneas
    textAlign: "justify",
  },

  ///Estilos para la cabecera
  headerTable: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    marginTop: 10,
  },
  logoColumn: {
    width: "100%",
    alignItems: "center",
  },

  tituloColumn: {
    width: "100%",
    alignItems: "center",
    marginRight: 5,
  },

  banner: {
    width: "90%",
    height: 60,
  },
  infoColumn: {
    width: "20%",
    borderWidth: 1,
    borderColor: "#000",
    height: 50, // asegúrate de tener un alto fijo para alinear contenido
  },

  codeRow: {
    padding: 5,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    justifyContent: "center", // centra verticalmente
    alignItems: "center", // centra horizontalmente
    height: 30, // divide en dos mitades, por ejemplo
  },

  codeText: {
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
  },

  dateVersionRow: {
    flexDirection: "row",
    height: "40px",
  },
  dateCell: {
    width: "45%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    paddingLeft: 8,
    justifyContent: "center",
    justifyContent: "flex-start", // alinear arriba
  },
  versionCell: {
    width: "55%",
    paddingLeft: 8,
    justifyContent: "center",
    justifyContent: "flex-start", // alinear arriba
  },
  text: {
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
  },
});

// Componente para renderizar celdas con flex y estilos
const TableCell = ({ children, flex, isLastCell }) => (
  <View style={[styles.tableCell, { flex }, isLastCell && styles.lastCell]}>
    <Text>{children}</Text>
  </View>
);
const ActaEntregaPDFAlmacenar = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.content}>
        <View fixed>
          <View style={styles.headerTable} fixed>
            <View style={styles.logoColumn}>
              <Image style={styles.banner} src={"Banner_membrete.png"} />
            </View>
          </View>

          <View style={styles.headerTable} fixed>
            <View style={styles.tituloColumn}>
              <Text
                style={[styles.title, styles.centeredText, styles.boldText]}
              >
                ACTA DE ENTREGA DE BIENES E INSUMOS ESTRATEGIA SOSTENIBILIDAD
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.table}>
          {/* Fila 1: 1 columnas */}
          <View style={styles.tableRow}>
            <TableCell flex={1} isLastCell>
              <Text style={styles.paragraph}>
                {`En el marco del Programa de Reincorporación Integral – PRI -, la Agencia para la Reincorporación y la Normalización diseñó la Estrategia de Sostenibilidad, como mecanismo de fortalecimiento y de apoyo complementario al proceso de reincorporación económica y social, a través del fortalecimiento a los proyectos individuales, colectivos e iniciativas productivas de firmantes de paz.`}

                {"\n"}
                {"\n"}
                {`La Organización de las Naciones Unidas para la Agricultura y la Alimentación-FAO-, en la ejecución de las actividades inherentes al convenio 1269-2024 (nomenclatura ARN) - UTF/COL/166/COL: Fortalecimiento de la sostenibilidad de los procesos de reincorporación económica y social,  cuyo objeto es fortalecer las capacidades institucionales de la ARN, de las personas y de las organizaciones sujetas del proceso de reincorporación, acompañando técnicamente la labor de la ARN en la implementación y sostenibilidad de los proyectos productivos aprobados por el CNR, brindando asistencia técnica especializada según la actividad específica de cada emprendimiento. De acuerdo a la propuesta de fortalecimiento técnico y económico de los proyectos productivos prorizados, realiza la entrega de los siguientes bienes:`}
              </Text>
            </TableCell>
          </View>

          <View style={styles.tableRow}>
            <TableCell style={styles.boldText} flex={6.7}>
              <Text style={styles.boldText}>
                Nombre completo de la forma organizativa:
              </Text>
            </TableCell>
            <TableCell flex={7}>
              {data?.implementador || ""} - {data?.sigla || ""}{" "}
            </TableCell>

            <TableCell style={styles.boldText} flex={3.3}>
              <Text style={styles.boldText}>CODIGO PRE / INI:</Text>
            </TableCell>

            <TableCell flex={2.5} isLastCell>
              {data?.codigo_pre || ""}
            </TableCell>
          </View>

          {/* Fila 2: 2 columnas */}
          <View style={styles.tableRow}>
            <TableCell style={styles.boldText} flex={3}>
              <Text style={styles.boldText}>
                Nombre del proyecto productivo{" "}
              </Text>
            </TableCell>
            <TableCell flex={6} isLastCell>
              {data?.proyecto_productivo || ""}
            </TableCell>
          </View>

          {/* Fila 2: 2 columnas */}
          <View style={styles.tableRow}>
            <TableCell style={styles.boldText} flex={3}>
              <Text style={styles.boldText}>Linea productiva: </Text>
            </TableCell>
            <TableCell flex={6} isLastCell>
              {data?.linea_productiva || ""}
            </TableCell>
          </View>

          <View style={styles.tableRow}>
            <TableCell style={styles.boldText} flex={7.9}>
              <Text style={styles.boldText}>Entrega Parcial: </Text>
            </TableCell>

            <TableCell flex={3}>
              <Text style={[styles.text, styles.boldText]}>X</Text>
            </TableCell>

            <TableCell style={styles.boldText} flex={3.6}>
              <Text style={styles.boldText}>Entrega Final: </Text>
            </TableCell>

            <TableCell flex={8.4} isLastCell></TableCell>
          </View>

          <View style={styles.tableRow}>
            <TableCell style={styles.boldText} flex={8.8}>
              <Text style={styles.boldText}>Grupo territorial:</Text>
            </TableCell>
            <TableCell flex={3.3}>{data?.grupo_territorial || ""}</TableCell>

            <TableCell style={styles.boldText} flex={4}>
              <Text style={styles.boldText}>Departamento: </Text>
            </TableCell>

            <TableCell flex={2.5}>{data?.departamento || ""}</TableCell>

            <TableCell style={styles.boldText} flex={3}>
              <Text style={styles.boldText}>Municipio:</Text>
            </TableCell>

            <TableCell flex={3} isLastCell>
              {data?.municipio || ""}
            </TableCell>
          </View>

          {/* Fila 2: 2 columnas */}
          <View style={styles.tableRow}>
            <TableCell style={styles.boldText} flex={3}>
              <Text style={styles.boldText}>
                Dirección del proyecto productivo/iniciativa{" "}
              </Text>
            </TableCell>
            <TableCell flex={6} isLastCell>
              {data?.direccion_proyecto_productivo || ""}
            </TableCell>
          </View>

          <View style={styles.tableRow}>
            <TableCell style={styles.boldText} flex={5}>
              <Text style={styles.boldText}>
                N° de personas en reincorporación vinculadas al proyecto
                productivo:{" "}
              </Text>
            </TableCell>
            <TableCell flex={2}>
              {data?.personas_reincorporacion || ""}
            </TableCell>

            <TableCell style={styles.boldText} flex={5.5}>
              <Text style={styles.boldText}>
                N° de personas de la comunidad:{" "}
              </Text>
            </TableCell>

            <TableCell flex={2} isLastCell>
              {data?.personas_comunidad || ""}
            </TableCell>
          </View>
        </View>

        <View style={styles.table} wrap={false}>
          {/* Puedes agregar más filas aquí igual */}
          {Array.isArray(data?.lista_participantes) &&
            data.lista_participantes.length >= 1 && (
              <>
                {/* Título de la sección */}
                <View style={[styles.tableRow, styles.tableRowColored]}>
                  <TableCell flex={1} isLastCell>
                    <Text style={[styles.title, styles.centeredText]}>
                      Se reúne(n) la(s) siguiente(s) persona(s) en proceso de
                      Reincorporación
                    </Text>
                  </TableCell>
                </View>

                {/* Cabecera de columnas */}
                <View style={[styles.tableRow, styles.tableHeader]}>
                  <TableCell flex={3}>
                    <Text style={[styles.text, styles.boldText]}>
                      NOMBRES Y APELLIDOS COMPLETOS
                    </Text>
                  </TableCell>
                  <TableCell flex={2}>
                    <Text style={[styles.text, styles.boldText]}>
                      N° Identificación
                    </Text>
                  </TableCell>
                  <TableCell flex={1} isLastCell>
                    <Text style={[styles.text, styles.boldText]}>
                      Código SIR
                    </Text>
                  </TableCell>
                </View>

                {/* Filas con datos */}
                {data.lista_participantes.slice(0, 5).map((persona, index) => (
                  <View key={`persona-${index}`} style={styles.tableRow}>
                    <TableCell flex={3}>
                      <Text style={styles.text}>
                        {persona.nombre_completo || ""}
                      </Text>
                    </TableCell>
                    <TableCell flex={2}>
                      <Text style={styles.text}>
                        {persona.identificacion || ""}
                      </Text>
                    </TableCell>
                    <TableCell flex={1} isLastCell>
                      <Text style={styles.text}>
                        {persona.codigo_sirr || ""}
                      </Text>
                    </TableCell>
                  </View>
                ))}

                {/* Filas vacías por defecto (para completar hasta 5) */}
                {Array.from({
                  length: Math.max(0, 5 - data.lista_participantes.length),
                }).map((_, idx) => (
                  <View
                    key={`empty-${idx}`}
                    style={[styles.tableRow, { minHeight: 18 }]} // 👈 alto fijo en px
                  >
                    <TableCell flex={3}>
                      <Text style={styles.text}></Text>
                    </TableCell>
                    <TableCell flex={2}>
                      <Text style={styles.text}></Text>
                    </TableCell>
                    <TableCell flex={1} isLastCell>
                      <Text style={styles.text}></Text>
                    </TableCell>
                  </View>
                ))}
              </>
            )}
        </View>

        <View style={styles.table}>
          {/* Fila 1: 1 columnas */}
          <View style={styles.tableRow}>
            <TableCell flex={1} isLastCell>
              <Text style={[styles.paragraph, { textAlign: "center" }]}>
                {`RELACIÓN DE BIENES A ENTREGAR AL PROYECTO PRODUCTIVO`}
                {"\n"}
                {"\n"}

                {`Afirmamos que recibimos a satisfacción los equipos, herramientas y/o insumos, cotizados en el Plan de sostenibilidad y fortalecimiento de la Estrategia de Sostenibilidad, por concepto de inversión del proyecto productivo / iniciativa, denominado (nombre del proyecto productivo), con código (código PRE/ Iniciativa) con la línea productiva (indique la línea productiva del proyecto/iniciativa).`}
              </Text>
            </TableCell>
          </View>

          {/* Fila 1: 1 columnas */}
          <View style={styles.tableRow}>
            <TableCell flex={1} isLastCell>
              <Text style={styles.paragraph}>
                {`Afirmo que recibí a satisfacción los equipos, herramientas y/o insumos, aprobados en el Plan de sostenibilidad y fortalecimiento de la Estrategia de Sostenibilidad, por concepto de inversión del proyecto productivo / iniciativa.`}
              </Text>
            </TableCell>
          </View>
        </View>

        <View style={styles.table}>
          {Array.isArray(data.lista_insumos) &&
            data.lista_insumos.length >= 1 && (
              <>
                {/* Cabecera de columnas */}
                <View style={[styles.tableRow, styles.tableHeader]}>
                  <TableCell flex={1}>
                    <Text style={[styles.text, styles.boldText]}>ITEM</Text>
                  </TableCell>
                  <TableCell flex={4}>
                    <Text style={[styles.text, styles.boldText]}>
                      DESCRIPCIÓN
                    </Text>
                  </TableCell>
                  <TableCell flex={2}>
                    <Text style={[styles.text, styles.boldText]}>
                      SERIAL (si aplica){" "}
                    </Text>
                  </TableCell>
                  <TableCell flex={1}>
                    <Text style={[styles.text, styles.boldText]}>UNIDAD</Text>
                  </TableCell>

                  <TableCell flex={1} isLastCell>
                    <Text style={[styles.text, styles.boldText]}>CANTIDAD</Text>
                  </TableCell>
                </View>

                {/* Filas con datos */}
                {data.lista_insumos.map((insumo, index) => (
                  <View key={index} style={styles.tableRow}>
                    <TableCell flex={1}>
                      <Text style={styles.text}>{insumo.item || ""}</Text>
                    </TableCell>
                    <TableCell flex={4}>
                      <Text style={[styles.text, { textAlign: "left" }]}>
                        {insumo.descripcion || ""}
                      </Text>
                    </TableCell>
                    <TableCell flex={2}>
                      <Text style={[styles.text, { textAlign: "left" }]}>
                        {Array.isArray(insumo.seriales) &&
                        insumo.seriales.length > 0
                          ? insumo.seriales.join("\n") // 👈 más simple que map + Text
                          : ""}{" "}
                      </Text>
                    </TableCell>

                    <TableCell flex={1}>
                      <Text style={styles.text}>{insumo.unidad || ""}</Text>
                    </TableCell>

                    <TableCell flex={1} isLastCell>
                      <Text style={styles.text}>{insumo.cantidad || ""}</Text>
                    </TableCell>
                  </View>
                ))}

                {/* Fila final con total */}
                <View style={[styles.tableRow, styles.tableRowColored]}>
                  <TableCell flex={6.8}>
                    <Text style={[styles.title, styles.centeredText]}>
                      VALOR TOTAL DE LA ENTREGA
                      {"\n"}
                      *Este valor corresponde a lo aprobado en el Plan de
                      Fortalecimiento
                    </Text>
                  </TableCell>
                  <TableCell flex={2} isLastCell>
                    <Text style={[styles.text, styles.boldText]}>
                      {data.valorTotalEntrega
                        ? `$ ${new Intl.NumberFormat("es-CO").format(
                            data.valorTotalEntrega
                          )}`
                        : ""}
                    </Text>
                  </TableCell>
                </View>
              </>
            )}

          {/* Fila 2: 2 columnas */}
          <View style={styles.tableRow}>
            <TableCell style={styles.boldText} flex={3}>
              <Text style={styles.boldText}>SITIO DE ENTREGA </Text>
            </TableCell>
            <TableCell flex={6} isLastCell>
              {data?.sitio_entrega || ""}
            </TableCell>
          </View>

          {/* Título de la sección */}
          <View style={[styles.tableRow, styles.tableRowColored]}>
            <TableCell flex={1} isLastCell>
              <Text style={[styles.title, styles.centeredText]}>
                CONDICIONES DE ENTREGA
              </Text>
            </TableCell>
          </View>
          {/* Fila 1: 1 columnas */}
          <View style={styles.tableRow}>
            <TableCell flex={1} isLastCell>
              <Text style={styles.paragraph}>
                {`Las personas en proceso de reincorporacion o sus formas asociativas se comprometen a cumplir con las siguientes condiciones:`}
                {"\n"}
                {"\n"}
                {`a) Los bienes o servicios recibidos serán de uso exclusivo y para los fines, propósitos y necesidades que se pretenden satisfacer con la ejecución del proyecto de la referencia, el cual fue concebido para obtener un beneficio tangible de la comunidad.
               b) Ningún particular podrá apropiarse de los bienes o servicios recibidos, por tener un uso, destinación y finalidad específica para el fortalecimiento de un colectivo.
               c) Está prohibida la venta o cualquier forma de comercialización de los bienes o servicios recibidos, por cuánto éstos buscan satisfacer las necesidades identificadas en la formulación del proyecto, salvo disposición contraria contemplada dentro del proyecto.
               d) Las personas en proceso de reincorporacion y/o sus formas organizativas como receptores de los bienes y servicios recibidos se comprometen, aceptan y entienden, las implicaciones de la administración e incluso las responsabilidades tributarias que se desprenden de la recepción de los bienes entregados.
               e) En el caso de equipos y herramientas que requieran expertiz en su manejo, las personas en proceso de reincorporacion y/o sus formas organizativas se comprometen a recibir la capacitación correspondiente y acatar las recomendaciones asociadas al buen uso, con el fin de poder hacer efectivas las garantías y el servicio de mantenimiento postventa acordados con el proveedor.
               f)  Las personas en proceso de reincorporacion y/o sus formas organizativas  en calidad de beneficiarios se comprometen a vincular y controlar tanto a sus activos como su partida patrimonial de los activos productivos entregados con el fin de mantener en el tiempo, su sostenibilidad financiera como existencia de estos.
               g) En el caso de vehículos la responsabilidad asociada al buen uso y manejo (impuestos, tasas, multas, daños a terceros, accidentes y manejo o conducción idoneos) del bien corre a cargo de la forma organizativa a partir de la fecha de entrega.`}
              </Text>
            </TableCell>
          </View>
          {/* Fila 1: 1 columnas */}
          <View style={styles.tableRow}>
            <TableCell flex={1} isLastCell>
              <Text style={[styles.paragraph, { textAlign: "center" }]}>
                {`Siendo hoy, día ${data?.dia || "_____"} mes ${
                  data?.mes || "___________"
                } de ${data?.vigencia || "____"}, firman:`}
              </Text>
            </TableCell>
          </View>
        </View>

        <View wrap={false}>
          <View style={[styles.table, { flexDirection: "row" }]}>
            {/* Columna izquierda: Primer y Segundo firmante */}
            <View
              style={{
                flex: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                padding: 8,
              }}
            >
              {/* Primer firmante */}
              <View style={styles.tableRow}>
                <TableCell flex={1} isLastCell>
                  <Text style={[styles.text, styles.boldText]}>
                    En representación de FAO
                  </Text>
                </TableCell>
              </View>
              <View style={styles.tableRow}>
                <TableCell flex={2}>
                  <Text style={[styles.text, styles.boldText]}>NOMBRE</Text>
                </TableCell>
                <TableCell flex={4} isLastCell>
                  <Text style={styles.text}>{""}</Text>
                </TableCell>
              </View>
              <View style={[styles.tableRow, { height: 60 }]}>
                <TableCell flex={2}>
                  <Text style={[styles.text, styles.boldText]}>FIRMA</Text>
                </TableCell>
                <TableCell flex={4} isLastCell>
                  <View style={[styles.signatureLine]} /> {/* Más alto */}
                </TableCell>
              </View>

              <View style={styles.tableRow}>
                <TableCell flex={1} isLastCell>
                  <Text style={[styles.text, styles.boldText]}>
                    En representación de ARN
                  </Text>
                </TableCell>
              </View>
              <View style={styles.tableRow}>
                <TableCell flex={2}>
                  <Text style={[styles.text, styles.boldText]}>NOMBRE</Text>
                </TableCell>
                <TableCell flex={4} isLastCell>
                  <Text style={styles.text}>{""}</Text>
                </TableCell>
              </View>
              <View style={[styles.tableRow, { height: 60 }]}>
                <TableCell flex={2}>
                  <Text style={[styles.text, styles.boldText]}>FIRMA</Text>
                </TableCell>
                <TableCell flex={4} isLastCell>
                  <View style={styles.signatureLine} />
                </TableCell>
              </View>
            </View>
            {/* Columna derecha: Tercer firmante */}
            <View style={{ flex: 1, padding: 8 }}>
              <View style={styles.tableRow}>
                <TableCell flex={1} isLastCell>
                  <Text style={[styles.text, styles.boldText]}>
                    Nombres completos de la persona en reincorporación o
                    Representante Legal de la forma organizativa/iniciativa que
                    lidera
                  </Text>
                </TableCell>
              </View>

              <View style={styles.tableRow}>
                <TableCell flex={2}>
                  <Text style={[styles.text, styles.boldText]}>NOMBRE</Text>
                </TableCell>
                <TableCell flex={4} isLastCell>
                  <Text style={styles.text}>
                    {data.lista_participantes.find(
                      (p) => p.es_representante_legal
                    )?.nombre_completo || ""}
                  </Text>
                </TableCell>
              </View>

              <View style={[styles.tableRow, { height: 60 }]}>
                <TableCell flex={2}>
                  <Text style={[styles.text, styles.boldText]}>FIRMA</Text>
                </TableCell>
                <TableCell flex={4} isLastCell>
                  <View style={styles.signatureLine} />
                </TableCell>
              </View>

              <View style={[styles.tableRow, { height: 90 }]}>
                <TableCell flex={2}>
                  <Text style={[styles.text, styles.boldText]}>HUELLA</Text>
                </TableCell>
                <TableCell flex={4} isLastCell>
                  <View style={styles.signatureLine} />
                </TableCell>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.table}>
          <View wrap={false}>
            {Array.isArray(data.lista_participantes) &&
              data.lista_participantes.length > 0 && (
                <View style={[styles.tableRow, styles.tableRowColored]}>
                  <TableCell flex={1} isLastCell>
                    <Text style={[styles.title, styles.centeredText]}>
                      FIRMA DE PERSONAS EN REINCORPORACIÓN QUE ACOMPAÑAN LA
                      ENTREGA
                    </Text>
                  </TableCell>
                </View>
              )}

            {Array.isArray(data.lista_participantes) &&
              data.lista_participantes.length > 0 &&
              (() => {
                // 🚀 Filtrar excluyendo al representante legal
                let participantes = data.lista_participantes.filter(
                  (p) => !p.es_representante_legal
                );

                // 👉 Limitar a máximo 4 participantes
                participantes = participantes.slice(0, 4);

                // 🚀 Agregar vacíos hasta completar 4
                while (participantes.length < 4) {
                  participantes.push(null);
                }

                // 👉 Si la cantidad es impar, agregamos un vacío más para cuadrar pares
                if (participantes.length % 2 !== 0) {
                  participantes.push(null);
                }

                // Agrupamos por pares (2 columnas)
                const filas = participantes.reduce((rows, persona, idx) => {
                  if (idx % 2 === 0) rows.push([persona]);
                  else rows[rows.length - 1].push(persona);
                  return rows;
                }, []);

                return filas.map((row, rowIdx) => (
                  <View key={rowIdx} style={{ flexDirection: "row" }}>
                    {row.map((persona, colIdx) => (
                      <View key={colIdx} style={{ flex: 1 }}>
                        {/* Fila: NOMBRE */}
                        <View style={styles.tableRow}>
                          <TableCell flex={2}>
                            <Text style={[styles.text, styles.boldText]}>
                              Nombre
                            </Text>
                          </TableCell>
                          <TableCell flex={4} isLastCell={colIdx === 1}>
                            <Text style={styles.text}>
                              {persona?.nombre_completo || ""}
                            </Text>
                          </TableCell>
                        </View>

                        {/* Fila: FIRMA */}
                        <View style={[styles.tableRow, { height: 60 }]}>
                          <TableCell flex={2}>
                            <Text style={[styles.text, styles.boldText]}>
                              Firma
                            </Text>
                          </TableCell>
                          <TableCell flex={4} isLastCell={colIdx === 1}>
                            <View style={styles.signatureLine} />
                          </TableCell>
                        </View>
                      </View>
                    ))}
                  </View>
                ));
              })()}
          </View>

          {/* Resto del contenido que no depende del listado */}
          <View style={[styles.tableRow, { height: 100 }]}>
            <TableCell flex={1} isLastCell>
              <Text style={[styles.paragraph, { textAlign: "center" }]}>
                {` Desarrollo – hallazgos – observaciones:`}
              </Text>
            </TableCell>
          </View>

          <View style={styles.tableRow}>
            <TableCell flex={1} isLastCell>
              <Text style={styles.paragraph}>
                {`i) Seguimiento al buen uso del bien: La ARN - FAO o los socios del convenio, podrán realizar seguimiento al buen uso de los bienes y/o servicios entregados, y en desarrollo de esas funciones podrán realizar visitas de verificación de los bienes en los lugares en donde ellos deben disponerse, así como solicitar los reportes que considere pertinentes para verificar el buen uso de los bienes. Las personas en proceso de reincorporacion o sus formas organizativas se comprometen a darle buen uso al bien objeto de esta entrega, y en especial, a no usarlo para ningún fin ilícito.
               
               ii) Durante el tiempo de ejecución del convenio de cooperación, FAO gestionará el proceso para hacer efectiva la garantía o servicio postventa de los equipos, herramientas y/o insumos suministrados. En los casos donde la garantía excede el tiempo de ejecución del convenio, FAO transferirá esta potestad a la forma organizativa a través de los documentos pertinentes definidos por FAO.
               
               iii) La transferencia de propiedad, para los bienes que superen los 1.500 dólares en su costo unitario (de acuerdo a la tasa de cambio de las Naciones Unidas), será refrendada por documentos internos de FAO, y que se firmarán de manera posterior a la presente acta por parte de las personas en proceso de reincorporacion y/o sus formas organizativas ya citados, pero que en todo caso hacen referencia a los bienes acá descritos y que cumplen dicho requisito de costo.
               
               iv) Inmunidades y privilegios de la FAO: Nada de lo dispuesto en este documento, ha de entenderse como una renuncia expresa o tácita al régimen de inmunidades y privilegios que le han sido reconocidos a la FAO en la Ley 62 de 1973 y demás normas relacionadas.
               
               v) Inmunidades y privilegios del bien: Una vez suscrita esta acta, el bien objeto de la entrega pierde los privilegios e inmunidades a los que estaba o pudiera llegar a estar sujeto en virtud de la ley 62 de 1973 y demás normas respectivas, toda vez que sale del dominio de la FAO. `}{" "}
                {/* contenido truncado para brevedad */}
              </Text>
            </TableCell>
          </View>

          <View style={[styles.tableRow, { height: 50 }]}>
            <TableCell flex={1} isLastCell>
              <Text style={[styles.paragraph, { textAlign: "center" }]}>
                {` FOTOGRAFÍAS DE LA ENTREGA`}
              </Text>
            </TableCell>
          </View>

          <View style={[styles.tableRow, { height: 50 }]}>
            <TableCell flex={1} isLastCell>
              <Text style={[styles.paragraph, { textAlign: "center" }]}>
                {` FOTOGRAFÍAS DE SERIALES DE EQUIPOS (Si aplica)`}
              </Text>
            </TableCell>
          </View>
        </View>
      </View>
    </Page>
  </Document>
);

export default ActaEntregaPDFAlmacenar;
